import {billingDiscountsQuery} from '@blesk-frontend/api';
import {Button, Crown, Loader, Modal, ModalProps} from '@blesk-frontend/ui';
import {useQuery} from '@tanstack/react-query';
import {Link, useNavigate} from '@tanstack/react-router';
import {useEffect} from 'react';

import {sendEvent} from '@/libs/analytics';

interface BillingDiscountModalProps extends ModalProps {
  discountId: string;
}

export const BillingDiscountModal = ({onClose, ...rest}: BillingDiscountModalProps) => {
  const navigate = useNavigate();

  const {data: discount, isLoading} = useQuery({
    ...billingDiscountsQuery,
    select: (data) => data?.find((d) => d.id === rest.discountId),
  });

  useEffect(() => {
    if (discount) {
      sendEvent('billing/discount:modal-show', {discountId: discount.id});
    }
  }, [discount]);

  const onClickClose = () => {
    navigate({to: window.location.pathname});
    onClose?.();
  };

  const onClickGetDiscount = () => {
    if (discount) {
      sendEvent('billing/discount:modal-click', {discountId: discount.id});
    }
    onClickClose();
  };

  if (isLoading || !discount) {
    return <Loader />;
  }

  return (
    <Modal {...rest} onClose={onClickClose}>
      <div className="mb-6 flex flex-col items-start gap-2 text-title-h1">
        <div className="rounded-md bg-brand-primary p-2">
          <Crown className="size-6 flex-1 text-attention-primary" />
        </div>
        <h1 className="text-title-h1">
          Разблокируйте <br /> больше возможностей <br /> со скидкой {discount.discount}%
        </h1>
      </div>
      <p className="mb-6 text-paragraph-md text-text-secondary">
        Откройте доступ к безлимитным инструкциям и другим полезным функциям Блеска, подключив
        подписку со скидкой {discount.discount}%.
      </p>
      <Link className="mb-6 block" to="/plans">
        <Button
          className="border-none bg-brand-primary hover:bg-brand-primary/90"
          type="button"
          onClick={onClickGetDiscount}
        >
          Получить скидку
        </Button>
      </Link>
      <p className="text-paragraph-md text-text-secondary">
        Предложение действует до {new Date(discount.expiresAt).toLocaleDateString('ru-RU')}
      </p>
    </Modal>
  );
};
